/**
 * Relatórios de e-mail — a casca do módulo.
 *
 * O provedor fica aqui, fora das telas, para que trocar de tela pelo menu não recarregue filtros e
 * preferências: as oito telas compartilham o mesmo período, os mesmos projetos e a mesma moeda.
 */
import { Suspense, lazy, useMemo } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import '@/components/v2/tokens.css';
import { Customize } from './components/Customize';
import { LoadingState } from './components/States';
import { SCREENS, type ScreenKey } from './lib/screens';
import { EmailProvider } from './state/store';

const SCREEN_COMPONENT: Record<ScreenKey, ReturnType<typeof lazy>> = {
    overview: lazy(() => import('./screens/Overview')),
    broadcasts: lazy(() => import('./screens/Broadcasts')),
    funnels: lazy(() => import('./screens/Funnels')),
    templates: lazy(() => import('./screens/Templates')),
    routes: lazy(() => import('./screens/Routes')),
    offers: lazy(() => import('./screens/Offers')),
    leads: lazy(() => import('./screens/Leads')),
    clicks: lazy(() => import('./screens/Clicks')),
};

export default function EmailV1() {
    const { pathname } = useLocation();
    const screen = useMemo<ScreenKey | null>(() => {
        const slug = pathname.replace(/^\/email\/?/, '').split('/')[0];
        return SCREENS.find((s) => s.path === slug)?.k ?? null;
    }, [pathname]);

    if (!screen) return <Navigate to="/email/geral" replace />;

    const Screen = SCREEN_COMPONENT[screen];
    return (
        <EmailProvider>
            {/* `.rv` é o escopo dos tokens v2; as margens negativas cancelam o padding do MainLayout
                para a barra da tela sangrar até a borda, como nas outras telas v2 */}
            <div className="rv -m-4 sm:-m-6" style={{ minHeight: '100%' }}>
                <Suspense fallback={<div style={{ padding: 24 }}><LoadingState chart /></div>}>
                    <Screen />
                </Suspense>
            </div>
            <Customize screenKey={screen} />
        </EmailProvider>
    );
}
